<template>
  <forum/>
</template>

<script>
import Forum from '../components/Forum/index'
export default {
  components: {Forum},

}
</script>

<style>

</style>
